import { FC, useMemo } from "react";
import { useParams } from "react-router";
import { TableModelProps } from "./types";
import {
  selectActiveByDatePromptsState,
  selectLoading as selectPromptsLoading,
  selectPromptsLoadError,
} from "../../store/selectors/prompts";
import { fetchPrompts } from "../../store/prompts/slice";
import { ERoutes } from "../../constants/routes";
import { selectScoresByModelState } from "../../store/selectors/scores";
import { fetchScoreModel } from "../../store/scores/slice";
import { fetchResponsesModel } from "../../store/response/slice";
import { useAppDispatch, useAppSelector } from "../../hooks";
import TableDaily from "../Table/TableDaily";
import { TableDailyConfig } from "../Table/types";
import { buildColumns, buildData } from "./utils/table";
import { Prompt } from "../../types/prompts";

const TableModel: FC<TableModelProps> = ({ model, index }) => {
  const { date } = useParams();
  const dispatch = useAppDispatch();
  const prompts = useAppSelector(selectActiveByDatePromptsState(date));
  const promptsLoading = useAppSelector(selectPromptsLoading);
  const promptsError = useAppSelector(selectPromptsLoadError);

  const config: TableDailyConfig<string> = useMemo(() => ({
    items: prompts,
    loading: promptsLoading,
    error: promptsError,
    onRetry: () => dispatch(fetchPrompts()),
    scoresSelector: selectScoresByModelState,
    buildColumns,
    buildData: (params) => {
      return buildData({
        prompts: params.items as Prompt[],
        promptsDailyBaseRoute: params.baseRoute,
        selectBrands: params.selectBrands,
        scoreModel: params.score,
        isScoreLoading: params.isScoreLoading,
      });
    },
    fetchScore: ({ date, entityId, brandIds }) => {
      dispatch(fetchScoreModel({ 
        date, 
        model_id: Number(entityId), 
        brand_ids: brandIds 
      }));
    },
    fetchResponses: ({ date, entityId, brandIds }) => {
      dispatch(fetchResponsesModel({ 
        date, 
        model_id: entityId, 
        brand_ids: brandIds 
      }));
    },
    baseRoute: ERoutes.PromptsDayly,
    navigateRoute: ERoutes.ModelsDayly,
    skeletonRows: 11,
  }), [prompts, promptsLoading, promptsError, dispatch]);

  return <TableDaily entityId={model.id} index={index} config={config} />;
};

export default TableModel;
